import Pagination from "react-js-pagination";
import React, {useState} from "react";
import * as Constants from "../../constants/urls";

export const PacksModal = (props) => {
    const [search ,setSearch]=useState("");
    return (
        <>
            <div className="location_modal text-right">
                <div className="location_modal_box">
                    <div className="location_modal_header bg-dark p-2">
                        <span className=" w-100 text-right text-white">انتخاب بسته</span>
                        <span onClick={props.close} className={"w-100 text-right text-danger pointer font-weight-bold font17 mx-3"}>  x </span>
                    </div>
                    <div className="col">
                        <input type="text" className={"form-control my-2"} placeholder={"جستجو نام یا بارکد محصول"} onChange={(e)=> {
                            props.search(e.target.value);
                        }}/>
                    </div>
                    <div className="list-group">
                        {
                            props.packs.data != undefined && props.packs.data != null && props.packs.data.map((item, index) => {
                                return (
                                    <div className={"list-group-item list-group-item-action"} onClick={() => {
                                        props.select(item.id)
                                    }}>
                                        <div className="d-flex w-100 justify-content-between">
                                            <div className="row my-1 p-1 w-100"  style={{background: "#00000008"}}>
                                                <div className="col-sm-3 col-4 mt-3 mt-md-0">
                                                    <img
                                                        src={Constants.imagesBsaeUrl + '/image/resizeTest/shop/_1000x/thumb_' + item.product.prodID + '.jpg'}
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            borderRadius: '2px',
                                                            cursor: "pointer"
                                                        }}/>
                                                </div>

                                                <div className="col-sm-9 col-8 mt-3 mt-md-0"
                                                     style={{fontSize: "12px", fontWeight: "bold"}}>
                                                    <p className="p-0 m-0 my-sm-2">{item.product.prodName_fa}</p>
                                                    <p className="p-0 m-0 my-sm-2">{item.label}</p>
                                                    <p className="p-0 m-0 my-sm-2">بارکد بسته : {item.barCode}  </p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className='pager Page navigation example'>
                        {props.packs!=undefined && <Pagination
                            totalItemsCount={props.packs.total}
                            activePage={props.packs.current_page}
                            itemsCountPerPage={props.packs.per_page}
                            onChange={(n)=>{props.get(n)}}
                            itemClass="page-item"
                            linkClass='page-link'
                            firstPageText="اولین صفحه"
                            lastPageText="آخرین صفحه"
                            nextPageText="بعدی"
                            prevPageText="قبلی"
                            activeClass='pageactive'
                        />}
                    </div>
                </div>
            </div>
        </>
    )
}
